import React from "react";
import MerchantTable from "./components/Table";
import { NavLink } from "react-router-dom";

const index = () => {
  return (
    <>
      <MerchantTable />
    </>
  );
};

export default index;
